export class User
{
    storeid: string;
    password: string;
    accounttype: string;
    userstore: string;
    role: string;
    balance: string;    
    createdate: string;    
}
  


// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/models/usermodel.ts